<template>
	<el-dialog title="押运员详情" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="dialog-container" style="max-height: 600px; overflow: auto">
			<p class="platTitle">基础信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>押运员名称</span>
						</div>
						<el-input v-model="yyName" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>身份证号:</span>
						</div>
						<el-input v-model="yyCardid" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>手机号:</span>
						</div>
						<el-input v-model="yyPhone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>性别:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="yySex" placeholder="性别">
								<el-option label="男" value="0" />
								<el-option label="女" value="1" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系人:</span>
						</div>
						<el-input v-model="yyEmcontact" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>紧急联系电话:</span>
						</div>
						<el-input v-model="yyEmphone" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>居住地址:</span>
						</div>
						<el-input v-model="yyHabitancy" class="platItemRigth" placeholder="请输入" />
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>类型:</span>
						</div>
						<div class="flex platItemRigth flex-y-center">
							<el-select v-model="yyType" placeholder="性别">
								<el-option label="加盟" value="0" />
								<el-option label="外调" value="1" />
								<el-option label="临时" value="2" />
							</el-select>
						</div>
					</div>
					<div class="w50 flex flex-y-center platItem">
						<div class="flex flex-y-center platItemLeft">
							<span class="input-fail">*</span>
							<span>备注:</span>
						</div>
						<el-input v-model="yyRemark" class="platItemRigth" placeholder="请输入" />
					</div>

				</div>
			</div>
			<p class="platTitle">从业资格证信息</p>
			<div class="info-input-container">
				<div class="flex flex-y-center flex-wrap">
					<div class="w50">
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证编号</span>
							</div>
							<el-input v-model="yyjcNo" class="platItemRigth" placeholder="请输入" />
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>从业日期</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="yyjcJobDate" type="date" :clearable="false"
									placeholder="请选择从业日期">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证发证日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="yyjcStartDate" type="date" :clearable="false"
									placeholder="请选择发证日">
								</el-date-picker>
							</div>
						</div>
						<div class="flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>资格证到期日</span>
							</div>
							<div class="flex platItemRigth flex-y-center">
								<el-date-picker v-model="yyjcEndDate" type="date" :clearable="false"
									placeholder="请选择到期日">
								</el-date-picker>
							</div>
						</div>
					</div>
					<div class="w50 platItem flex" style="align-items: flex-start"  ref="refyyjc">
						<div class="flex flex-y-center platItemLeft">

							<span>从业资格证照</span>
						</div>
						<div class="flex flex-y-center flex-x-between platItemRigth">
							<div class="upRpic_icon_item2" v-if="yyjcPhotoUrl == ''">
								<img class="upRpic_icon" src="@/assets/images/upload-icon.png" />
								<span class="fontSize14 col-999">上传图片</span>
							</div>
							<div class="upRpic_icon_item2" v-else>
								<img class="upRpic2_icon" :data-original="yyjcPhotoUrl" :src="yyjcPhotoUrl" />
							</div>
						</div>
					</div>
				</div>
			</div>

			<span class="dialog-footer">
				<span class="btn bg-default" v-on:click="closeModal()">关闭</span>
			</span>
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import Viewer from "viewerjs";
	import "viewerjs/dist/viewer.css";
	import "@riophae/vue-treeselect/dist/vue-treeselect.css";
	export default defineComponent({
		name: "Edit",
		emits: ["getData"],
		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const getData = () => {
				context.emit("getData");
			};
			onMounted(() => {
				nextTick(() => {});
			});
			const data = reactive({
				isDetail: false,
				treeData: [],
				roleList: [],
				defaultProps: {
					children: "children",
					label: "text",
				},
				valueTitle: "",
				isShowTree: false,
				yyUserId: "",
				yyOrg: "2", //所属机构
				yyOrgUsing: "2", //机构级别 0本机构1本级及下级2本级及下级所有
				yyCardid: "2", //身份证号
				yyName: "2", //司机名称
				yyPhone: "19211112221", //手机号
				yyType: "", //司机类型0加盟1外调2临时
				yyDriveType: "2", //准驾车型
				yySex: "", //性别0男1女
				yyWeixin: "", //微信号
				yyEmcontact: "", //紧急联系人
				yyEmphone: "", //紧急联系电话
				yyHabitancy: "", //居住地
				yyPhotoUrl: "http", //押运员照片
				yyRemark: "", //备注
				yyjcNo: "", //从业资格证编号
				yyjcJobDate: "2025-04-09 17:12:59", //从业日期
				yyjcStartDate: "2025-04-09 17:12:05", //从业资格证发证日
				yyjcEndDate: "2025-05-01 17:12:07", //从业资格证到期日
				yyjcPhotoUrl: "", //从业资格证图片

			});
			//重置数据
			const init = async (id) => {
				data.isDetail = true;
				data.yyUserId = id;

				let params = {
					yyUserId: id,
				};
				const r = await proxy.$http.get(apiObj.yyDetail, params);
				if (r) {
					data.yyCardid = r.yayunInfo.yyCardid;
					data.yyName = r.yayunInfo.yyName;
					data.yyPhone = r.yayunInfo.yyPhone;
					data.yyType = r.yayunInfo.yyType;
					data.yySex = r.yayunInfo.yySex;
					data.yyWeixin = r.yayunInfo.yyWeixin;
					data.yyEmcontact = r.yayunInfo.yyEmcontact;
					data.yyEmphone = r.yayunInfo.yyEmphone;
					data.yyHabitancy = r.yayunInfo.yyHabitancy;
					data.yyPhotoUrl = r.yayunInfo.yyPhotoUrl;
					data.yyRemark = r.yayunInfo.yyRemark;
					data.yyjcNo = r.yyJobCertificate.yyjcNo;
					data.yyjcJobDate = r.yyJobCertificate.yyjcJobDate;
					data.yyjcStartDate = r.yyJobCertificate.yyjcStartDate;
					data.yyjcEndDate = r.yyJobCertificate.yyjcEndDate;
					data.yyjcPhotoUrl = r.yyJobCertificate.yyjcPhotoUrl;
				}
				
				setTimeout(() => {
					lookImg();
				}, 1500);

			};


			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};
			const submit = async () => {


				if (data.yyName == "") {
					proxy.$message.error("请填写押运员名称");
					return;
				}
				if (data.yyPhone == "") {
					proxy.$message.error("请填写手机号");
					return;
				}

				let params = {
					yyUserId: data.yyUserId,
					yyCardid: data.yyCardid,
					yyName: data.yyName,
					yyPhone: data.yyPhone,
					yyType: data.yyType,
					yySex: data.yySex,
					yyWeixin: data.yyWeixin,
					yyEmcontact: data.yyEmcontact,
					yyEmphone: data.yyEmphone,
					yyHabitancy: data.yyHabitancy,
					yyPhotoUrl: data.yyPhotoUrl,
					yyRemark: data.yyRemark,
					yyJobCertificate: {
						yyjcNo: data.yyjcNo,
						yyjcJobDate: data.yyjcJobDate,
						yyjcStartDate: data.yyjcStartDate,
						yyjcEndDate: data.yyjcEndDate,
						yyjcPhotoUrl: data.yyjcPhotoUrl
					}
				}

				const r = await proxy.$http.post(apiObj.yyUpdate, params)
				console.log(r);
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					getData();
					data.isEdit = false;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}

			};

			//查看图片
			const lookImg = () => {
				const ref1Dom = proxy.$refs.refyyjc;
				if (ref1Dom != undefined) {
					const zfhtViewer = new Viewer(ref1Dom, {
						inline: false, // 不使用内联模式，强制弹出（使用内联样式就会在页面展示，不弹出）
						navbar: true, // 显示导航
						title: false, // 隐藏标题
						toolbar: true, // 显示工具栏
						zoomable: true, // 支持缩放
						rotatable: true, // 支持旋转
						scalable: true, // 支持缩放
						transition: true, // 启用过渡效果
						//    url: "data-original",
						// zIndex: 4000,
					});
				}
			}
			
			return {
				...toRefs(data),
				init,
				closeModal,
				getData,
				dialogClosedHandle,
				submit
			};
		},
	});
</script>
<style scoped>
	.page_warp {
		width: 100%;
		max-height: 600px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 100px;
		font-size: 18px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 42px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 100px;
		justify-content: flex-end;
	}

	.platItem input {
		width: 70%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}
</style>